import '../context-menu.css';

import React from 'react';

import { toolbarDivider } from '../../../../pages/mindmap/tool-bar/get-menu-divider';
import { FormatTextContentMenuColoringSector } from './format-text-content-menu-coloring-sector';
import { FormatTextContentMenuLinkingSector } from './format-text-context-menu-linking-sector';
import { FormatTextContentMenuStylingSector } from './format-text-context-menu-styling-sector';

export const FormatTextContextMenu = () => {
  return (
    <div className="context-menu">
      <div className="context-menu-item">
        <FormatTextContentMenuStylingSector />
      </div>
      {toolbarDivider()}
      <div className="context-menu-item">
        <FormatTextContentMenuColoringSector />
      </div>
      {toolbarDivider()}
      <div className="context-menu-item">
        <FormatTextContentMenuLinkingSector />
      </div>
    </div>
  );
};
